import popup from '../popup/index';
import { IMarker, IComponent } from '../../../types/common';

const EVENT_COLOR = Object.freeze({
  'Cvs Ptd': 'rgba(255, 0, 0, 0.7)',
  'Cvs Wild': 'rgba(33, 103, 219, 0.7)',
  Single: 'rgba(255, 204, 0, 0.7)',
  Unprod: 'rgba(128, 128, 128, 0.7)',
});

const isTrap = (marker: IMarker) => marker.type === 'trap';

const color = (marker: IMarker): string => {
  if (!isTrap(marker))
    return EVENT_COLOR[marker.event] || marker.color || 'rgba(255, 0, 0, 0.8)'; // #FF0000
  if (marker.successRate <= 10) return 'rgba(255, 255, 178, 0.8)'; // '#FFFFB2';
  if (marker.successRate <= 20) return 'rgba(254, 204, 92, 0.8)'; // '#FECC5C';
  if (marker.successRate <= 30) return 'rgba(253, 140, 60, 0.8)'; // '#FD8D3C';
  if (marker.successRate <= 40) return 'rgba(240, 59, 32, 0.8)'; // '#F03B20';
  return 'rgba(189, 0, 38, 0.8)'; // '#BD0026';
};

const fontColor = (marker: IMarker): string => {
  if (!isTrap(marker)) {
    return null;
  }
  if (marker.successRate <= 10) return 'dimgray';
  if (marker.successRate <= 20) return 'dimgray';
  if (marker.successRate <= 30) return 'white';
  if (marker.successRate <= 40) return 'white';
  return null;
};

const element = (marker: IMarker): Element => {
  const el = document.createElement('div');
  el.className = 'covey-marker';
  el.innerText = isTrap(marker)
    ? marker.trapNumber
    : marker.inaccurate
    ? 'I/A'
    : '';
  el.style.backgroundColor = marker.color;
  el.style.color = marker.fontColor;
  return el;
};

const init = (marker: IMarker): IComponent => {
  const prepared = {
    ...marker,
    color: color(marker),
    fontColor: fontColor(marker),
  };
  return {
    element: element(prepared),
    popup: popup.marker(prepared),
  };
};

export default init;
